import { generate } from "shortid";
import { TARGET_DATA } from "../../../forms";
import { PAGE_TYPES, PAGE_THEMES } from "../../types";

export const PREMIUM_PROGRAM_PAGES = {
  program_category_page: {
    id: `program_category_page-${generate()}`,
    type: PAGE_TYPES.category,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.MELLOW,
    data: {
      title: "How oVRcome will help",
      description: null,
      image: "illustrations/winking-face",
      continue_button_label: "See the program",
      custom_back: "gender_select_page",
      default_progression: "program_clinical_lesson_page",
      options: [],
    },
  },
  program_clinical_lesson_page: {
    id: `program_clinical_lesson_page-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "team",
      custom_back: null,
      default_progression: "program_exposure_lesson_page",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "In your first week",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/program-white",
          text: "Learn from psychologists",
          description:
            "Our clinical psychologists have developed audio lessons, exercises, and tools to make learning easy, applicable, and effective.\n\nMeet our team of experts:",
          isActive: true,
        },
      ],
    },
  },
  program_exposure_lesson_page: {
    id: `program_exposure_lesson_page-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/program-vr-plan",
      custom_back: null,
      default_progression: "program_life_lesson_page",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "In your first week",
          value: null,
          target_field: null,
          to: null,
          icon: "program",
          text: "Learn from psychologists",
          description:
            "Our clinical psychologists have developed audio lessons, exercises, and tools for you make learning easy, applicable, and effective. Meet our team of experts:",
          isActive: false,
        },
        {
          id: `step-item-2-${generate()}`,
          label: "In 2+ weeks",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/vr-white",
          text: "VR exposure therapy",
          description:
            "Once you’ve received your VR headset watch simulations repeatedly, the exposure desensitizes you.",
          isActive: true,
        },
      ],
    },
  },
  program_life_lesson_page: {
    id: `program_life_lesson_page-${generate()}`,
    type: PAGE_TYPES.step,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: null,
      description: "oVRcome is all about doing a little bit, often.",
      image: "illustrations/track-progress",
      custom_back: null,
      default_progression: "program_how_vr_works_page",
      options: [
        {
          id: `step-item-1-${generate()}`,
          label: "In your first week",
          value: null,
          target_field: null,
          to: null,
          icon: "program",
          text: "Learn from psychologists",
          description:
            "Our clinical psychologists have developed audio lessons, exercises, and tools for you make learning easy, applicable, and effective. Meet our team of experts:",
          isActive: false,
        },
        {
          id: `step-item-2-${generate()}`,
          label: "In 2+ weeks",
          value: null,
          target_field: null,
          to: null,
          icon: "vr",
          text: "VR exposure therapy",
          description:
            "Once you’ve received your VR headset watch simulations repeatedly, the exposure desensitizes you. Progress to higher intensity simulations and conquer them!",
          isActive: false,
        },
        {
          id: `step-item-3-${generate()}`,
          label: "In 10+ weeks",
          value: null,
          target_field: null,
          to: null,
          icon: "__deprecated/reports-white",
          text: "Consistent, lifelong impact",
          description:
            "Track your improvement confronting fears and overcoming avoidance in the real world.",
          isActive: true,
        },
      ],
    },
  },
  program_how_vr_works_page: {
    id: `program_how_vr_works_page-${generate()}`,
    type: PAGE_TYPES.summary,
    backwards_navigation_enabled: true,
    title: "Your personalized program",
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How does VR work?",
      description:
        "We’ll send you a VR headset so you can use your phone to experience VR simulations.  Right to your door. Anywhere in the world.",
      image: "illustrations/winking-face",
      custom_back: null,
      default_progression: "web_payment_setup_account_page",
      options: [
        {
          id: `image-item-1-${generate()}`,
          label: "Insert your mobile phone into the provided headset.",
          value: null,
          target_field: null,
          to: null,
          icon: "vr-headset",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `image-item-2-${generate()}`,
          label: "Pop it on your head and start watching.",
          value: null,
          target_field: null,
          to: null,
          icon: "vr-headset-on-girl",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  program_little_bit_often: {
    id: `program_little_bit_often-${generate()}`,
    type: PAGE_TYPES.info,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.MELLOW,
    data: {
      title: "oVRcome is all about doing a little bit often",
      description:
        "Experience safe and controlled Virtual Reality environments from the privacy of your own home.",
      image: "vr-headset-on-girl-2",
      continue_button_label: "Continue",
      custom_back: "gender_select_page",
      default_progression: "web_payment_setup_account_page",
      options: [],
    },
  },
};
